<template>
<v-dialog v-model="dialogCreatealbums" persistent max-width="500px" max-height="500px" style="overflow-y: hidden;">
  <v-card style="border-radius:20px;">
    <v-card tile>
      <v-toolbar card style="background: #1a222c !important;">
        <v-toolbar-title class="white--text CSChatThai">
          <v-icon color="white">fas fa-images</v-icon>&nbsp;&nbsp;{{$t('Dialog.album.headerCreate')}}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon flat @click="closeDialog">
          <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
        </v-btn>
      </v-toolbar>
    </v-card>
    <v-card-text style="padding-left: 30px;">
      <div style="height:275px; overflow-y: hidden; margin-top: 10px;">
        <div class="">
          <v-text-field name="name" :label="$t('Alert.Fail.Album.emptyName')" id="id" v-model="albumsname"></v-text-field>
        </div>
        <div>
          <form ref="fileform" style="float: left;">
            <label>
              <b class="CSChatThai" style="text-decoration: underline; cursor: pointer;text-indent: 5em;">{{$t('AnswerQuestion.selectPicture')}}</b>
              <input type="file" id="files" ref="files" multiple v-on:change="handleFilesUpload()" style="display: none;" accept=".png, .jpg, .jpeg, .gif, .bmp, .wbmp" />
            </label>
          </form>
          <v-flex xs12 sm12 md12 v-if="files.length > 0 " style="overflow-x: scroll;overflow-y: hidden; height: 40vh !important; width: 100% !important; display: -webkit-inline-box;  padding-top: 3px;" class="containers">
            <div class="borderfile" v-for="(file, key) in files" style="justify-content: center; margin-left: 2vw; padding-top: 1vh;">
              <a style="float: right; padding-right: 10px; font-size: 20px;" class="close-classic" @click="removeFile( key )"></a>
              <div v-if="extension(file.file.name) == 'fas fa-file-image'" style="text-align: center; display: grid; justify-content: center;">
                <img class="preview" v-bind:ref="'preview'+parseInt( key )"
                  style="height: 18vh !important; width:20vh !important;display: flex;justify-content: center; border-radius: 10px; border-color: #8080808f; border-style: solid; border-width: thin;" />
                <!-- <b class="text2">{{ file.file.name }}</b> -->
              </div>
              <div v-else style="text-align: center; display: grid; justify-content: center;">
                <v-icon style="font-size: 60px !important; color: #1a222c;display: flex;justify-content: center;">{{ extension(file.file.name)}}</v-icon>
                <!-- <b class="text2">{{ file.file.name }}</b> -->
              </div>
            </div>
          </v-flex>
        </div>
      </div>
      <v-layout row wrap justify-center align-center>
        <v-btn dark @click="closeDialog" style="background: #757575; text-transform: none;">
          {{$t('AnswerQuestion.cancel')}}
        </v-btn>
        <v-btn dark @click="createalbums()" v-if="files.length > 0 && albumsname !== ''" style="background: #2562ae; text-transform: none;" :loading="loading">
          {{$t('AnswerQuestion.ok')}}
        </v-btn>
        <v-btn v-else disabled style="background: #2562ae; text-transform: none;">
          {{$t('AnswerQuestion.ok')}}
        </v-btn>
      </v-layout>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
<script>
// import { Momenttime } from '@/services'
import {
  Decode
} from '@/services'
var _ = require('lodash')
export default {
  props: {
    dialogCreatealbums: false,
    tokenroom: ''
  },
  data: () => ({
    token: '',
    files: [],
    albumsname: '',
    loading: false
  }),
  created () {
    // this.token = Decode.decodeToken(this.$cookie.get('tokenuser'))
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
  },
  methods: {
    closeDialog () {
      this.files = []
      this.albumsname = ''
      this.$emit('closeCreatealbums', false)
    },
    createalbums () {
      // console.log(this.files)
      var sizealums = []
      let formData = new FormData()
      var lengthfile = this.files.length
      for (var i = 0; i < lengthfile; i++) {
        var file = this.files[i].file
        formData.append('file[]', file, file.name)
        sizealums[i] = this.files[i].file.size
        // console.log(file)
      }
      if (_.sum(sizealums)/ 1024 / 1024 > 25) {
        this.$swal({ title: this.$t('Alert.Fail.Album.maxSizeFile'), type: 'warning' })
        this.files = []
        this.loading = false
      } else {
        this.loading = true
        formData.append('tokenuser', this.token)
        formData.append('tokenroom', this.$route.params.roomid)
        formData.append('albums_name', this.albumsname)
        this.axios.post(process.env.APIpub + '/create_album', formData).then((response) => {
          this.loading = false
          var infoalbums = {}
          infoalbums = response.data.data.albums
          // console.log(infoalbums)
          this.$swal('', this.$t('Alert.Success.createAlbum'), 'success')
          this.$emit('CreateAlbums', response.data.status, infoalbums)
          this.files = []
          this.albumsname = ''
          this.$emit('closeCreatealbums', false)
        }, () => {
          this.loading = false
          this.$swal('Network error', this.$t('Alert.Fail.default.networkError'), 'error')
        })
      }
    },
    extension (files) {
      var extension = files.split('.')[files.split('.').length - 1].toLowerCase()
      var archive = ['zip', 'jar', 'rar', 'tar', 'a', 'ar', 'shar', '7z', 'arj', 'deb', 'pkg', 'gz', 'rpm', 'z']
      var pdf = ['pdf']
      var file = ['ai', 'ps', 'psd']
      var spreadsheet = ['xls', 'xlt', 'xlsm', 'xlm', 'xlsm']
      var presentation = ['ppt', 'pps', 'pot', 'pptx']
      var word = ['doc', 'docx', 'dot', 'dotx', 'dotm', 'docm', 'docb', 'wbk']
      var execution = ['apk', 'bat', 'bin', 'pl', 'cgi', 'com', 'exe', 'gadget', 'jar', 'py', 'vue', 'wsf', 'css', 'htm', 'html', 'js', 'php', 'xhtml', 'c', 'class', 'cpp', 'vb', 'h', 'sh', 'swift']
      var image = ['gif', 'jpeg', 'jpg', 'png', 'bmp', 'ico', 'svg', 'tif', 'tiff']
      if (pdf.includes(extension)) {
        return 'fas fa-file-pdf'
      } else if (archive.includes(extension)) {
        return 'fas fa-file-archive'
      } else if (spreadsheet.includes(extension)) {
        return 'fas fa-file-excel'
      } else if (presentation.includes(extension)) {
        return 'fas fa-file-powerpoint'
      } else if (word.includes(extension)) {
        return 'fas fa-file-word'
      } else if (execution.includes(extension)) {
        return 'fas fa-file-code'
      } else if (image.includes(extension)) {
        return 'fas fa-file-image'
      } else if (file.includes(extension)) {
        return 'fas fa-file'
      } else {
        return 'fas fa-file-alt'
      }
      // return extension[extension.length-1]
    },
    handleFilesUpload (key) {
      let uploadedFiles = this.$refs.files.files
      for (var i = 0; i < uploadedFiles.length; i++) {
        this.files.push({
          file: uploadedFiles[i],
          status: 'waiting'
        })
      }
      this.getImagePreviews(key)
      document.querySelector('#files').value = ''
    },
    removeFile (key) {
      this.files.splice(key, 1)
      this.getImagePreviews(key)
    },
    getImagePreviews (key) {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].file.name)) {
          let reader = new FileReader()
          reader.addEventListener('load', function() {
            this.$refs['preview' + parseInt(i)][0].src = reader.result
            // console.log(this.$refs['preview' + parseInt(i)][0].src = reader.result)
          }.bind(this), false)
          reader.readAsDataURL(this.files[i].file)
          // this.extension(this.files[i].name)
          // console.log(this.extension())
        } else {
          // this.$nextTick(function(){
          // this.$refs['preview'+parseInt( i )][0].src = '/images/file.png'
          // });
          // console.log('mm')
        }
      }
    }
  },
  watch: {
    files () {
      if (this.files.length > 5) {
        this.$swal(
          '',
          this.$t('Alert.Fail.Album.maxFiles'),
          'warning'
        )
        _.pullAt(this.files, [5])
      }
    }
  }
}
</script>
<style type="text/css" scoped>
.text2 {
  white-space: nowrap;
  width: 70px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.close-classic:after {
  content: '×';
  /* ANSI X letter */
}

.containers {
  width: 576px;
  margin: 0 auto;
}

.containers:after {
  content: '';
  display: block;
  clear: both;
}

.borderfile {
  border: 1px solid #00000036;
  border-radius: 5px;
  width: 45vw !important;
  height: 20vh !important;
  position: relative;
  background: white;
}

.Kanit {
  font-family: 'Kanit', sans-serif !important;
}

.alligator-turtle {

  object-fit: cover;
  object-position: 50% 0;
}

.application .theme--light.input-group input,
.application .theme--light.input-group textarea,
.theme--light .input-group input,
.theme--light .input-group textarea {
  /* color: rgba(0,0,0,.87); */
  color: #53ceff !important;
}

.CSChatThai {
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
}

.user-photonote {
  height: 40px !important;
  width: 40px !important;
  background: #ccc;
  border-radius: 50%;
  overflow: hidden;

}

.textchat {
  white-space: nowrap;
  max-width: 9em;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: 'CS ChatThaiUI' !important;
  text-transform: none;
  display: inline-flex;
}

input[type=textadd] {

  width: 100%;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  background-color: white;
  /*background-image: url('../assets/image/group.png');*/
  background-position: 10px 10px;
  background-repeat: no-repeat;
  padding: 12px 12px 12px 12px;
  -webkit-transition: width 0.4s ease-in-out;
  transition: width 0.4s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/dialog/CreateAlbumsDialogMobile.vue